import {authStore} from '@/composables/store-accessor'

export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.client && !from) return
    const $conf = useNuxtApp().$conf
    if (to.name === 'userAutoLogin' || to.name === 'hotelDirectory') return
    if ($conf.public.account.disableB2BRegistration && to.name === 'b2b-register') {
        return navigateTo({name: 'b2b-auth'})
    }
    if (!$conf.public.onlyRegistered) return
    const role = authStore.person?.role,
        authPageName = $conf.public.onlyRegistered === 'client' ? 'authorization' : 'b2b-auth',
        regPageName = $conf.public.onlyRegistered === 'client' ? 'register' : 'b2b-register',
        signInPages = [authPageName, regPageName, 'restore-password']
    if ([authPageName, regPageName, 'restore-password'].includes(<string>to.name) && role) {
        return navigateTo({name: 'home'})
    } else if (
        (!role && !signInPages.includes(<string>to.name)) ||
        ($conf.public.onlyRegistered === 'corporate' && to.name === regPageName)
    ) {
        return navigateTo({name: authPageName})
    }
})
